import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import {JwtHelperService} from '@auth0/angular-jwt';
import {Observable} from 'rxjs';
import {AuthorizationService} from '../services/authorization.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizeGuard implements CanActivate {

  constructor(public authorizationService: AuthorizationService, public router: Router) {

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if(!this.authorizationService.authenticated.value) {
      if(next && next.url && next.url.length > 0) {
        this.router.navigate(['login', {url: next.url[0].path}]);
        //    this.services.userService.showLogin({ url: next.url[0].path });
      } else {
        this.router.navigate(['login']);
      }
      return false;
    } else return true;
  }

}
